import { render } from "./footer.vue?vue&type=template&id=a2ea2048"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
script.render = render

export default script